<template>
  <div class="container mt-4">
    <h4 class="mb-4">Manage Salary Advance Requests</h4>

    <div class="card shadow border-0">
      <div class="card-header text-white fw-bold" style="background-color: #b03a45;">
        <i class="material-icons me-2">request_quote</i> Salary Advances Table
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="text-uppercase small" style="background-color: #f8f9fa;">
            <tr>
              <th>Employee</th>
              <th>Amount</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Supervisor</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="advance in salaryAdvances" :key="advance.id">
              <td>{{ advance.user?.firstname }} {{ advance.user?.lastname }}</td>
              <td>{{ advance.amount }} TND</td>
              <td>{{ advance.reason || '—' }}</td>
              <td>
                <span :class="['badge', statusClass(advance.status)]">
                  {{ advance.status }}
                </span>
              </td>
              <td>{{ advance.supervisor?.firstname }} {{ advance.supervisor?.lastname }}</td>
              <td>
                <button v-if="advance.status === 'Pending'" class="btn btn-success btn-sm" @click="approveAdvance(advance.id)">
                  ✔ Approve
                </button>
                <button v-if="advance.status === 'Pending'" class="btn btn-danger btn-sm" @click="rejectAdvance(advance.id)">
                  ✘ Reject
                </button>
              </td>
            </tr>
            <tr v-if="salaryAdvances.length === 0">
              <td colspan="6" class="text-center text-muted py-4">No salary advance requests found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/api'
import { useToast } from 'vue-toastification'

const toast = useToast()
const salaryAdvances = ref([])

const fetchSalaryAdvances = async () => {
  try {
    const res = await axios.get('/employee/salary-advances')
    salaryAdvances.value = res.data.advances || []
  } catch (err) {
    toast.error('Failed to load salary advances')
  }
}

const approveAdvance = async (id) => {
  try {
    await axios.post(`/employee/salary-advances/approve/${id}`)
    toast.success('✅ Salary advance approved')
    fetchSalaryAdvances()
  } catch (err) {
    toast.error('❌ Approval failed')
  }
}

const rejectAdvance = async (id) => {
  try {
    await axios.post(`/employee/salary-advances/reject/${id}`)
    toast.success('✅ Salary advance rejected')
    fetchSalaryAdvances()
  } catch (err) {
    toast.error('❌ Rejection failed')
  }
}

const statusClass = (status) => {
  switch (status) {
    case 'Approved':
      return 'bg-success text-white'
    case 'Rejected':
      return 'bg-danger text-white'
    default:
      return 'bg-secondary text-white'
  }
}

onMounted(fetchSalaryAdvances)
</script>
